module.exports = __webpack_public_path__ + "static/media/btn_red.4b2aef9e.png";